import { render, staticRenderFns } from "./DynamicDataFieldAttributes.vue?vue&type=template&id=48cf7ffc&"
import script from "./DynamicDataFieldAttributes.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataFieldAttributes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports